const initAutoSubmit = function(form) {
	const autoSubmitInputs = form.element.querySelectorAll('[data-auto-submit]');
	if (!autoSubmitInputs || autoSubmitInputs.length < 1) return;

	if (autoSubmitInputs.length > 1)
		return console.error('[Form / Auto Submit] Only one field can have auto submit.');

	const input = autoSubmitInputs[0];
	const ignoreSpaces = input.dataset.autoSubmit.includes('ignore-spaces');
	const maxlength = parseInt(input.getAttribute('maxlength') || input.dataset.maxlength);

	if (!maxlength || maxlength < 1)
		return console.error('[Form / Auto Submit] maxlength required for auto submit on field ', input);

	let antiSpamCounter = 0;
	let submittedValue = '';

	const checkLength = function() {
		let currentValue = input.value;
		if (ignoreSpaces) currentValue = currentValue.replace(/\s/g, '');

		if (currentValue.length !== maxlength) return;
		if (currentValue === submittedValue) return;
		if (antiSpamCounter > 5) return input.removeEventListener('input', checkLength);
		if (form.processing.status !== false) return;
		antiSpamCounter ++;
		submittedValue = currentValue;
		form.submit();
	};

	input.addEventListener('input', checkLength);
};

export default initAutoSubmit;